import { z } from 'zod';

/** Formula-injection guard: rejects cells starting with = + - @ tab or CR. */
const FORMULA_PREFIX_RE = /^[=+\-@\t\r]/;
const noFormulaPrefix = (label: string) =>
  z
    .string()
    .trim()
    .min(1, `${label} is required`)
    .refine((value) => !FORMULA_PREFIX_RE.test(value), {
      message: `${label} cannot start with =, +, -, @ or a control character`
    });

/** CSV import per-row validation (email, first_name, last_name, type). */
export const CSV_IMPORT_ROW_SCHEMA = z.object({
  email: z
    .string()
    .trim()
    .toLowerCase()
    .email('Invalid email')
    .refine((value) => !FORMULA_PREFIX_RE.test(value), {
      message: 'Email cannot start with =, +, - or @'
    }),
  first_name: noFormulaPrefix('First name'),
  last_name: noFormulaPrefix('Last name'),
  // Optional per row: a missing or blank cell (and a missing column) defaults to
  // 'internal', so imports only need to spell out the exceptions.
  type: z
    .preprocess(
      (value) => {
        const normalised = typeof value === 'string' ? value.trim().toLowerCase() : '';
        return normalised === '' ? 'internal' : normalised;
      },
      z.enum(['internal', 'external', 'any'])
    )
    .describe('User type — internal (default), external, or any (combination)')
});

export type CsvImportRow = z.infer<typeof CSV_IMPORT_ROW_SCHEMA>;

/** Hard cap — must match BULK_USER_CREATE_MAX_ROWS in the backend. */
export const CSV_IMPORT_MAX_ROWS = 500;

/** Max welcome-email sends fired concurrently per batch. */
export const RESEND_EMAIL_CHUNK_SIZE = 100;
